import { omitBy, isEmpty, isNil } from 'lodash';

interface Data {
    type: 'MOBILE' | 'HOME' | 'OFFICE' | 'FAX';
    dialCode?: string;
    countryCode?: string;
    number: string;
}

const model = (data: Data) => {
  if (isEmpty(data))
    return {}

  return omitBy({
      type: data.type,
      countryCode: data.dialCode || data.countryCode,
      number: data.number,
      fullNumber: data.dialCode
        ? `${data.dialCode}${data.number}`
        : `${data.countryCode}${data.number}`
  }, isNil)
}

export default model;
